import { ClickEvent, MapPin, MapVendor,Map, PanelProps } from "@mcleod/components";
import { AutogenLayoutRequestLocation } from "./autogen/AutogenLayoutRequestLocation";
import { Api, LogManager, MapSettings, StringUtil, UrlUtil } from "@mcleod/core";

interface TextLocateInfo {
    orderId: string;
    companyName: string;
    baseUrl: string;
    isValidToken: boolean;
    movementId: string;
    requestLocationVendor: string;
    alwaysShowMap: string;

}
const log = LogManager.getLogger("powerbroker/RequestLocation");

export class RequestLocation extends AutogenLayoutRequestLocation{
    private requestLocationVendor: string;
    private alwaysShowMap: string;
    private latitude : number;
    private longitude : number;
    private orderId: string;
    private movementId: string;
    private companyName: string;
    private retryLocationRequested: boolean = false;
    private map: Map;

    override async onLoad() {
        const props = UrlUtil.getPropsFromUrl(document.location.search);
        const isTokenValid =  await this.validateToken(props.orderId, props.movementId, props.code);
        const userContainer = document.getElementById("userContainer");
        if(userContainer){
            userContainer.style.display = "none";
            const elements = document.getElementsByClassName("cmp-base btn-base btn-round");
            const elementsArray = Array.from(elements);
            elementsArray.forEach((element: HTMLElement) => {
                if (element && element.style) {
                    element.style.visibility = "hidden";
                }
            });
        }
        if(isTokenValid) {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition( this.onLocationSuccess.bind(this), this.onLocationError.bind(this));
            } else {
                this.setFields("Geolocation is not supported by this browser.");
            }
        }
    }

    private async onLocationSuccess(position: GeolocationPosition) {
        this.labelCurrentLocation.visible = true;
        this.btnDontShare.visible = true;
        this.btnShareLocation.visible = true;
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        await this.createMap();
        try {
            Api.post("lme/powerbroker/find-city-state", {
                latitude: this.latitude,
                longitude: this.longitude
            }).then(async response => {
                if (response?.data !== undefined && response?.data[0] !== undefined) {
                    this.labelLocationInfo.text = response?.data[0]?.current_city + ", " + response?.data[0]?.current_state;
                    if (!StringUtil.isEmptyString(this.requestLocationVendor) && !StringUtil.equalsIgnoreCase(this.requestLocationVendor, "N")) {
                        this.setUpMap(this.latitude, this.longitude);
                        this.panelMapContainer.add(this.map);
                    } else {
                        this.map.visible = false;
                    }
                }
            });
        } catch (ex) {
            if (ex && !StringUtil.isEmptyString(ex)) {
                log.debug(ex);
            }
        }
    }

    private onLocationError(error: GeolocationPositionError): void {
        if (error.code === error.PERMISSION_DENIED) {
            if (!this.retryLocationRequested) {
                this.setFields("Please allow access to your location.");
                navigator.geolocation.getCurrentPosition(this.onLocationSuccess.bind(this), this.onLocationError.bind(this));
                this.retryLocationRequested = true;
            }
        }
    }


    btnShareLocationOnClick(event: ClickEvent){
              Api.post("lme/powerbroker/create-text-locate-callin", {
                  order_id: this.orderId
                  ,latitude: this.latitude
                  ,longitude: this.longitude
                  ,movement_id: this.movementId }).then((response) => {
                      if(response && response.data?.[0]?.callin_created){
                          this.setFields("Your location has been shared with " + this.companyName + "! Order: " + this.orderId );
                      }else{
                          this.setFields("Error occurred while sharing location.");
                      }
              });

    }

    btnDontShareOnClick(event: ClickEvent){
        this.setFields("The request to share your location has been declined.");
    }


    private async validateToken(order_id: string, movement_id: string, code: string): Promise<boolean> {
        if (StringUtil.isEmptyString(code)) {
            this.labelLocationConfirmation.text = "Code is not valid.";
            return false;
        }
        try {
            const response = await Api.post("lme/powerbroker/validate-request-location-token", { order_id, movement_id, code });
            if (response.data && response.data[0]?.text_locate_info) {
                const textLocateData: TextLocateInfo = response.data[0].text_locate_info;

                if (!textLocateData.isValidToken) {
                    this.setFields("The provided token is invalid.");
                    return false;
                } else {
                    this.setValidTokenFields();
                    this.labelCompany.text = textLocateData.companyName;
                    this.labelOrderIdNumber.text = textLocateData.orderId;
                    this.orderId = textLocateData.orderId;
                    this.movementId = textLocateData.movementId;
                    this.companyName = textLocateData.companyName;
                    this.requestLocationVendor = textLocateData.requestLocationVendor;
                    this.alwaysShowMap = textLocateData.alwaysShowMap;

                    return true;
                }
            }
            return false;
        } catch (err) {
            if (err && !StringUtil.isEmptyString(err)) {
                log.debug(err);
                this.setFields("The provided token is invalid.");
                return false;
            }
            return false;
        }
    }

     setFields(message:string) {
         this.labelLocationConfirmation.text = message;
        this.labelOrderId.visible = false;
        this.labelOrderIdNumber.visible = false;
        this.labelRequestInfo.visible = false;
        this.labelCompany.visible = false;
        this.labelCurrentLocation.visible = false;
        this.labelLocationInfo.visible = false;
        this.btnDontShare.visible = false;
        this.btnShareLocation.visible = false;
      //  this.map.visible = false;
    }

    setValidTokenFields(){
        this.labelOrderId.visible = true;
        this.labelOrderIdNumber.visible = true;
        this.labelRequestInfo.visible = true;
        this.labelCompany.visible = true;

    }

    setUpMap(latitude: number, longitude: number){
        this.addPositionPin(latitude,longitude);
    }

    private async createMap() {
            this.map = new Map({
                "borderRadius": 4,
                "dataSource": this.mainDataSource,
                "fillHeight": true,
                "fillRow": true,
                "id": "map1",
                "latitudeField": this.latitude.toString(),
                "longitudeField": this.longitude.toString(),
                "vendor": this.setMapVendor(this.requestLocationVendor),
                "disableDefaultUI": true,
                "immediatelyActivateMap": true,
                "singleRecord":true
            });
            await this.map.ensureLocationMapLoaded(this.alwaysShowMap);
        }


    addPositionPin(latitude: number, longitude: number) {
        const pin = new MapPin(latitude,longitude);
        pin.image = "map-pin-white-dot-large";
        pin.captionColor = "Blue";
        pin.tooltip = "Current Location";
        pin.clusterable = false;
        this.map.setZoom(this.setZoomLevel(this.requestLocationVendor));
        this.map.setCenter(latitude, longitude);
        this.map.addPin(pin);
        this.map.fitPins();

    }

    private setMapVendor(requestLocationVendor: string) {
        if(StringUtil.isEmptyString(requestLocationVendor)){
            return MapVendor.NONE;
        }else if(StringUtil.equalsIgnoreCase(requestLocationVendor,"W")){
            return MapVendor.TRIMBLE;
        }
        return MapVendor.GOOGLE;
    }

    private setZoomLevel(requestLocationVendor: string) {
        if(StringUtil.isEmptyString(requestLocationVendor)){
            return 0;
        }else if(StringUtil.equalsIgnoreCase(requestLocationVendor,"W")){
            return 10;
        }
        return 14;
    }
}
